import type {
  CallsMetric,
  EngagementKpiMetric,
  ExecutiveMetric,
  GrowthMetric,
  MobileWeeklyTrend,
  ThermostatWeeklyTrend,
  TopDevice,
} from "./types"

export const DEFAULT_REPORTING_PERIOD = ""

export const executiveMetrics: Array<Pick<ExecutiveMetric, "title">> = [
  { title: "Total Engagement Actions" },
  { title: "Thermostat Engagement" },
  { title: "Mobile App Engagement" },
  { title: "Total Conversions" },
]

export const growthMetrics: Array<Pick<GrowthMetric, "title">> = [
  { title: "Customers" },
  { title: "Thermostats" },
  { title: "App Installs" },
]

export const thermostatKpis: Array<Pick<EngagementKpiMetric, "id" | "title" | "subtitle">> = [
  {
    id: "clicks",
    title: "Clicks on Logo",
    subtitle: "Customer interactions on thermostat devices",
  },
  {
    id: "qr-scans",
    title: "QR Scans",
    subtitle: "Scans of contractor QR code from thermostat interface.",
  },
]

export const thermostatWeeklyTrend: ThermostatWeeklyTrend[] = []

export const topDevices: TopDevice[] = []

export const mobileKpiGroups: Array<{
  title: string
  metrics: Array<Pick<EngagementKpiMetric, "id" | "title" | "subtitle">>
}> = [
  {
    title: "Navigation Actions",
    metrics: [
      {
        id: "mobile-clicks",
        title: "Clicks on Logo (App)",
        subtitle: "Clicks on contractor logo within the mobile app.",
      },
      {
        id: "support-clicks",
        title: "Support Tab Clicks",
        subtitle: "Clicks on the Support tab in the mobile app.",
      },
    ],
  },
  {
    title: "Website Actions",
    metrics: [
      {
        id: "website-actions",
        title: "Initial Website Clicks",
        subtitle: 'Initial clicks on "Visit Website" button in the mobile app.',
      },
      {
        id: "website-conversion",
        title: "Continue to Website (Conversion)",
        subtitle: "Confirmation clicks to proceed to contractor website.",
      },
    ],
  },
  {
    title: "Technician Requests",
    metrics: [
      {
        id: "technician-clicks",
        title: "Request Technician Clicks",
        subtitle: 'Initial clicks on "Request Technician" button in the mobile app.',
      },
      {
        id: "technician-conversion",
        title: "Continue to Request (Conversion)",
        subtitle: "Confirmation clicks to proceed with technician request.",
      },
    ],
  },
  {
    title: "Direct Contact Actions (High Intent)",
    metrics: [
      {
        id: "app-calls",
        title: "App Calls",
        subtitle: "Clicks to initiate phone call from the mobile app.",
      },
      {
        id: "app-texts",
        title: "App Texts",
        subtitle: "Clicks to initiate text message from the mobile app.",
      },
    ],
  },
]

export const mobileWeeklyTrend: MobileWeeklyTrend[] = []

export const callsSection: { metrics: Array<Pick<CallsMetric, "id" | "title" | "sourceLabel">> } = {
  metrics: [
    { id: "calls-taken", title: "Calls Taken", sourceLabel: "via Twilio" },
    { id: "connected", title: "Connected", sourceLabel: "via Twilio" },
    { id: "answered-by-human", title: "Answered by a Human", sourceLabel: "via Twilio" },
    { id: "avg-talk-time", title: "Avg Talk Time", sourceLabel: "via Twilio" },
  ],
}
